<template>
  <div class="modalBox">
    <Card class="left">
      <p slot="title">选择</p>
      <Input
        style="margin-bottom: 15px"
        v-model="keyword"
        placeholder="搜索"
        @on-change="handlerSearchange"
      />
      <div
        v-if="this.multiple"
        style="
          border-bottom: 1px solid #e9e9e9;
          padding-bottom: 6px;
          margin-bottom: 6px;
        "
      >
        <Checkbox :value="checkAll" @click.prevent.native="handleCheckAll">
          全选
        </Checkbox>
      </div>
      <Tree
        ref="tree"
        class="demo-tree-render"
        :data.sync="list"
        :show-checkbox="multiple"
        :render="renderContent"
        @on-select-change="onSelectChange"
        @on-check-change="onCheckChange"
        :check-strictly="true"
      />
    </Card>
    <Card class="center"></Card>
    <Card class="right">
      <p slot="title">已选</p>
      <Row
        :gutter="24"
        class="leftContent"
        v-for="(item, index) in selectList"
        :key="item.id + index"
      >
        <Col :span="20" class="text">
          <Tooltip v-showtip placement="top" transfer>
            <div slot="content" style="white-space: normal">
              {{ item.title }}
            </div>
            <div class="ellipsis">
              <span class="ellipse-text">{{ item.title }}</span>
            </div>
          </Tooltip>
        </Col>
        <Col :span="4">
          <Icon class="cursor" type="md-close" @click="deleteItem(item)" />
        </Col>
      </Row>
    </Card>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import {
  roleUseCheckeAll,
  checkAllSelect,
  getCurrentData,
  setRoleSelectIds,
  personGetTreeList,
  setItemChecked,
  myDebounce
} from './util';
export default {
  props: {
    // title展示
    title: {
      type: String,
      default: ''
    },
    // 是否多选  true 多选  false 单选
    multiple: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    showPath: {
      type: Boolean,
      default: true
    },
    needSelected: {
      type: Boolean,
      default: false
    },
    allData: {
      type: Array,
      default: () => []
    },
    baseId: {
      type: String,
      default: ''
    },
    customTreeList: {
      type: Array,
      default: () => []
    },
    searchList: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    },
    selectList: {
      type: Array,
      default: () => []
    },
    selectGroupIds: {
      type: Array,
      default: () => []
    },
    selectedIds: {
      type: Array,
      default: () => []
    },
    originData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      checkBoxData: [],
      activeId: '',
      keyword: '',
      checkAll: false
    };
  },
  computed: {
    ...mapState('dataManage', ['disabledId'])
  },
  methods: {
    renderContent(h, { root, node, data }) {
      const disabled = this.disabledId === data.id;
      return h('span', {
        class: {
          disabledClick: disabled
        }
      }, data.title);
    },
    handleItemClick(slectItem) {
      // 只有单选才会走这边的逻辑，多选走checkbox
      /*
        判断一下是选择部门还是选择人员
        如果是选择人员的话，但是选择的是部门的数据，就啥也不做
        如果是选择部门的话，走筛选的逻辑
      */
      if (this.type == 'person' && slectItem.isGroup) {
        return false;
      }
      // 判断是单选还是多选
      // 如果是单选的话，就替换掉
      // 如果是多选，就差看一下是否已经存在过了，如果存在过，就不再添加了，如果没有存在过，就加上
      this.checkBoxData = [slectItem.id];
    },
    deleteItem(item) {
      // 如果是多选的时候把checkbox里面的数据也给清空,因为checkBox监听操作了，不需要更改selectlist内容了
      const obj = getCurrentData(this.list, item.id);
      obj.checked = false;
      if (obj.parentNode) {
        obj.parentNode.checked = false;
      }
      const selectedIds = this.selectedIds.filter(id => id != item.id);
      this.$emit('update:selectedIds', selectedIds);
      setRoleSelectIds(this.list, selectedIds);
      // this.selectList = this.selectList.filter((i) => i.id != item.id);
      this.$emit(
        'update:selectList',
        this.selectList.filter(i => i.id != item.id)
      );
    },
    handlerSearchange: myDebounce(function() {
      const value = this.keyword;
      // this.$emit('on-input-change', value);
      const cloneDeepTree = _.cloneDeep(this.customTreeList);
      let searcheTree = setRoleSelectIds(cloneDeepTree, this.selectedIds);
      if (!value) {
        searcheTree = setRoleSelectIds(cloneDeepTree, this.selectedIds);
      } else {
        searcheTree = personGetTreeList(searcheTree, value, this.selectedIds);
      }
      console.log('searcheTree', searcheTree);
      // this.list = searcheTree;
      this.$emit('update:list', searcheTree);
    }, 500),

    handleCheckAll() {
      if (this.list.length < 1) return false;
      this.checkAll = !this.checkAll;
      // this.$emit('on-select-all', { type: this.type, checkAll: this.checkAll });
      const {
        setSelectList,
        deleteSelectList,
        addSelectList
      } = roleUseCheckeAll(this.list, this.checkAll, this.selectList);
      let selectGroupIds = [];
      let selectList = [];
      if (this.checkAll) {
        selectList = setSelectList;
        selectGroupIds = this.originData
          .filter(item => item.isGroup)
          .map(i => i.id);
      } else {
        // 筛选
        const ids = deleteSelectList.map(i => i.id);
        selectList = setSelectList.filter(item => !ids.includes(item.id));
        selectGroupIds = [];
      }
      const upDateSelectList = selectList.map(item => {
        const { id, pid, title } = item;
        return { id, pid, title };
      });
      const ids = selectList.map(i => i.id);
      this.$emit('update:selectedIds', ids);
      this.$emit('update:selectGroupIds', selectGroupIds);
      this.$emit('update:selectList', upDateSelectList);
    },
    onCheckChange(arr, changeItem) {
      // checked 为 true 是选中，为 false 是取消选中
      const isDelete = !changeItem.checked;
      let selectedIds = [...this.selectedIds];
      let selectGroupIds = [...this.selectGroupIds];
      if (changeItem.isGroup) {
        // 如果是选中状态
        let selectList = [...this.selectList];
        const selectListIds = this.selectList.map(i => i.id);
        if (changeItem.checked) {
          selectGroupIds = [...selectList, changeItem.id];
          this.$emit('update:selectGroupIds', selectGroupIds);
          if (changeItem.children && changeItem.children.length > 0) {
            // 如果是选中的部门，则筛选一下已经选中的，然后把未选中的选择上
            const filterChildren = changeItem.children.filter(
              i => !selectListIds.includes(i.id)
            );
            filterChildren.forEach(child => {
              if (!child.isGroup) {
                child.checked = true;
                selectedIds = [...selectedIds, child.id];
                selectList.push(child);
              }
            });
          }
        } else {
          // 如果是非选中状态
          selectGroupIds = selectGroupIds.filter(id => id != changeItem.id);
          this.$emit('update:selectGroupIds', selectGroupIds);
          if (changeItem.children && changeItem.children.length > 0) {
            // 把children 里面的 checked 改为 false
            const ids = [];
            changeItem.children.forEach(child => {
              if (!child.isGroup) {
                child.checked = false;
                selectedIds = selectedIds.filter(id => id != child.id);
                ids.push(child.id);
              }
            });
            selectList = selectList.filter(item => !ids.includes(item.id));
          }
        }
        const selectMap = selectList.map(item => {
          const { id, title, pid } = item;
          return {
            id,
            title,
            pid
          };
        });
        this.$emit('update:selectList', selectMap);
      } else {
        if (changeItem.checked) {
          const selectList = [...this.selectList, changeItem];
          selectedIds = [...selectedIds, changeItem.id];
          // 如果已经选中的数据和兄弟元素一样的话，就把父组件的checked=true
          if (changeItem.parentNode) {
            const childrenFilter = changeItem.parentNode.children.filter(
              item => !item.isGroup
            );
            const checked = childrenFilter.every(child => child.checked);
            if (checked) {
              changeItem.parentNode.checked = true;
            }
          }
          const selectMap = selectList.map(item => {
            const { id, title, pid } = item;
            return {
              id,
              title,
              pid
            };
          });
          this.$emit('update:selectList', selectMap);
        } else {
          // 如果是单选并且是非选中，就把父级勾选取消
          // 需要把其他树节点的也选中
          selectedIds = selectedIds.filter(id => id != changeItem.id);
          if (changeItem.parentNode) {
            changeItem.parentNode.checked = false;
            selectGroupIds = [
              ...selectGroupIds.filter(id => changeItem.parentNode.id != id)
            ];
          }
          this.$emit(
            'update:selectList',
            this.selectList.filter(item => item.id != changeItem.id)
          );
        }
      }
      setRoleSelectIds(this.list, selectedIds);
      this.$emit('update:selectedIds', [...new Set(selectedIds)]);
    },
    onSelectChange(arr, item) {
      // 禁用逻辑处理
      const disabled = this.disabledId === item.id;
      if (disabled) return;
      // 如果是多选的话，这个方法直接不执行了
      if (this.multiple) return (item.selected = false);
      // 此时是单选，一般是用来选择人员的，所以 如果是部门的话，就直接什么也不敢
      if (item.isGroup) return (item.selected = false);
      // 如果是点击的是人员的话，就让选择上
      const { id, pid, title } = item;
      this.$emit('update:selectList', [{ id, pid, title }]);
      return (item.selected = false);
    }
  },
  watch: {
    selectList: {
      deep: true,
      handler(newVal, oldVal) {
        const ids = newVal.map(item => item.id);
        const customTreeList = setItemChecked(
          this.customTreeList,
          ids,
          this.selectGroupIds
        );
        // this.customTreeList = customTreeList;
        this.$emit('update:customTreeList', customTreeList);
      }
    },
    list: {
      deep: true,
      immediate: true,
      handler(newVal) {
        let checkedAll = checkAllSelect(newVal);
        if (newVal.length == 0) {
          checkedAll = false;
        }
        this.checkAll = checkedAll;
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .ivu-tree-title .disabledClick{
  cursor: not-allowed;
  color: #ccc;
}
.modalBox {
  display: flex;
  height: 400px;
}
.modalBox .left,
.modalBox .center,
.modalBox .right {
  height: 100%;
}
.left,
.right {
  width: 45%;
  overflow-y: auto;
  overflow-x: hidden;
}
.center {
  width: 10%;
}
.leftContent {
  margin: 5px 0;
}
.cursor {
  cursor: pointer;
}
.ellipsis {
  width: 255px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
